<template>
  <div class="wordBox">
    <video
      id="videoElement"
      controls
      autoplay
      muted
      preload="auto"
      style="width: 100%; height: 100%; object-fit: fill"
    ></video>
  </div>
</template>

<script>
import webcu2plugin from 'webcu2plugin'
import flvjs from 'flv.js'
export default {
  data () {
    return {
      count: 0,
      flvToken: '',
      flvPlayer: null
    }
  },
  props: {
    puid: String
  },
  mounted () {
    this.initPlay()
  },
  beforeDestroy () {
    this.destroyVideos()
  },
  methods: {
    incrementCount () {
      this.count++
    },
    eventCallback (params) {
      if (params.type === 'playEvent') {
        console.log(params)
      } else if (params.type === 'downloadEvent') {
        console.log(params)
      } else if (params.type === 'userOnline') {
        console.log(params)
      } else if (params.type === 'userOffline') {
        console.log(params)
      } else if (params.type === 'deviceOnline') {
        console.log(params)
      } else if (params.type === 'deviceOffline') {
        console.log(params)
      }
    },
    createVedio (url) {
      var videoElement = document.getElementById('videoElement')
      this.flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false
      }
        ,
      {
        // enableWorker: false,
        // autoCleanupSourceBuffer: true,
        // enableStashBuffer: false,
        // stashInitialSize: 128,
        // statisticsInfoReportInterval: 600,
        enableWorker: false,
        autoCleanupSourceBuffer: true, // 清理缓冲区
        statisticsInfoReportInterval: 600,
        stashBufferSize: 32 * 1024 * 1024, // 缓存区大小（单位：字节）（可选）
        lazyLoad: true,
        lazyLoadMaxDuration: 30 * 60,
        stashInitialSize: 128, // 设置初始缓冲区大小为0
        enableStashBuffer: true // 启用缓存
      }
      )
      this.flvPlayer.attachMediaElement(videoElement)

      this.flvPlayer.on('loading_complete', (errType, errDetail) => {
        // if (this.this.flvPlayer) {
        // this.flvPlayer.attachMediaElement(videoElement)
        // this.flvPlayer.load()
        this.flvPlayer.pause()

        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
        this.initPlay()

        console.log('视频到底了')
        // this.destroyVideos()
        // // this.createthis.FlvPlayer(source)
        // this.autoLogin()
        // }
      })

      this.flvPlayer.load()
      setTimeout(() => {
        this.flvPlayer.play()
      }, 200)
    },
    initPlay () {
      webcu2plugin.logout()
      webcu2plugin.login({
        address: '61.185.238.249',
        port: 9988,
        user: 'ceshi',
        password: 'Zcw123456',
        epid: 'system',
        fixaddr: 0
      }, this.eventCallback).then((data) => {
        // console.log('data+++++++++++++++++++++++++++', data)
        this.flvToken = data.token
        localStorage.setItem('flvToken', data.token)
        if (data && data.code === 0) {
          webcu2plugin.getDeviceByPuid({ puid: this.puid, token: data.token }, this.eventCallback)
            .then((dev) => {
              // console.log(dev, '----------------------------------------------------------')
              console.log('dev', dev.Res)
              if (dev && dev.Res && dev.Res.length > 0) {
                const res = dev.Res.findIndex((iv) => iv.Type === 'IV')
                console.log(res)
                if (res >= 0) {
                  webcu2plugin.getPlayVideoId({ puid: this.puid, idx: res, stream: 0, token: data.token }, this.eventCallback)
                    .then((play) => {
                      console.log('play', play)
                      if (play) {
                        // const url = `http://localhost:${play.port}/stream2.flv?playID=${play.playID}`
                        const url = `http://127.0.0.1:9585/stream2.flv?playID=${play.playID}`
                        console.log('url', url)
                        this.createVedio(url)
                      }
                    })
                }
              }
            })
        }
      })
    },
    // 停止流
    destroyVideos () {
      if (!this.flvPlayer) return
      this.flvPlayer.pause()
      this.flvPlayer.unload()
      this.flvPlayer.detachMediaElement()
      this.flvPlayer.destroy()
      this.flvPlayer = null
    }
  }
}
</script>

<style scoped>
.read-the-docs {
  color: #888;
}
.wordBox {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/HelloWorld.vue